import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import { IPdflink, ICommission_bulletin, ICommission_bulletin_line, IFormula } from "../../types/interfaces";
import { formulaTagsExp, getAvailableVarsComm, getCommissionType } from "../../services/misc";
import { constants } from "../../types/constants";

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

const MyDocument: any = Document
const MyPage: any = Page

const CommissionDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const columns: any[] = [{value: "Projet", width: 10, modifySizeBy: -1}, {value: "Type Comm.", width: 15, modifySizeBy: -1}, {value: "Détails", width: 38}, {value: "M.C.", width: 7, modifySizeBy: 2}, {value: "Commission", width: 10, formatNumber: true}, {value: "Bns/Mls", width: 10, formatNumber: true}, {value: "Total", width: 10, formatNumber: true}],
    bulletin: ICommission_bulletin = data,
    usedFormulas: (IFormula | undefined)[] = bulletin.commission_bulletin_lines?.filter((e, index, self) => self.findIndex(t => t.commission_history?.formulaId === e.commission_history?.formulaId) === index).map(e => e.commission_history?.formula) || [],
    firstDate = bulletin.commission_bulletin_lines?.length && bulletin.commission_bulletin_lines?.reduce((a, b) => a.commission_history?.createdAt < b.commission_history?.createdAt ? a : b).commission_history?.createdAt,
    lastDate = bulletin.commission_bulletin_lines?.length && bulletin.commission_bulletin_lines?.reduce((a, b) => a.commission_history?.createdAt > b.commission_history?.createdAt ? a : b).commission_history?.createdAt;
  
  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid';
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING,
      paddingBottom: PAGE_SIDE_PADDING + (usedFormulas.length * 13)
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 15
    },
    middleLogoContainer1: {
      flex: 5
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    clientTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 20
    },
    clientTitleView1: {
      width: "100%"
    },
    clientTitleView2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      marginVertical: 6,
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans',
      textAlign: "center",
      fontSize: 18,
      backgroundColor: "#fefefe",
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    table: { 
      // display: "table", 
      width: "auto", 
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderRightWidth: 0, 
      borderBottomWidth: 0,
      marginBottom: 15
    },
    tableRow: { 
      margin: "auto", 
      flexDirection: "row" 
    },
    // footerRow: { 
    //   marginLeft: COL1_WIDTH + '%', 
    //   flexDirection: "row" 
    // },
    headerCol: { 
      backgroundColor: "#62af42",
      color: "white",
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderBottomColor: 'green',
      borderWidth: 1,
      fontWeight: 600,
      textAlign: "center"
    },
    rowCol: { 
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      textAlign: "center",
      fontFamily: 'Open Sans',
      fontWeight: 300,
      // borderLeftWidth: 0,
      // borderTopWidth: 0 
    },
    footerCol: {
      backgroundColor: "#62af42",
      color: "white",
      fontWeight: 600
    },
    cellText: { 
      marginVertical: 5,
      // marginHorizontal: 2,
      textAlign: "center",
      fontSize: 8
    },
    headerText: {
      fontWeight: 600
    },
    logo: {
      height: "auto",
      flex: 1
    },
    dateFournisseurView: {
      color: "#555555",
      fontSize: 12,
      // width: "100%",
      fontFamily: 'Open Sans',
      justifyContent: "flex-end",
      flexDirection: "row",
      marginBottom: 10
    },
    bvView: {
      color: "#000000",
      fontSize: 11,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "column",
      marginLeft: 2,
      marginBottom: 10
    },
    titlesView: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginTop: 7,
      marginBottom: 7
    },
    cardContainer1: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    cardContainer2: {
      // display: "table",
      width: "100%"
    },
    clientCardContainer: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      fontFamily: 'Open Sans',
      color: "#000000",
      fontSize: 11,
    },
    cardRow: {
      width: "100%",
      flexDirection: "row",
      // marginBottom: 4,
      marginVertical: 0,
      paddingVertical: 0,
    },
    cardCellTitle: {
      fontStyle: "italic",
      width: "20%"
    },
    cardCellValue: {
      fontWeight: 600,
      width: "20%"
    },
    cardCellSpace: {
      width: "20%"
    },
    clientCardCellTitle: {
      fontWeight: 600,
      borderRightWidth: 2,
      borderRightColor: "green",
      borderRightStyle: "solid",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#f2f2f2",
      flex: 1
    },
    clientCardCellValue: {
      fontStyle: "italic",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#fefefe",
      flex: 1
    },
    arreteView: {
      color: "#333333",
      fontSize: 10,
      fontStyle: "italic",
      fontFamily: 'Open Sans',
      width: "100%",
      marginTop: 20
    },
    directionText: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      marginLeft: "70%",
      marginTop: 25
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 14,
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    },
    formulaIdDiv: {
      color: "white",
    }
  });
  
  const lines: any[][] = (bulletin.commission_bulletin_lines || []).map(e => [
    e.commission_history?.societe?.LIBELE || "-",
    getCommissionType(e.commission_history?.type),
    // (e.commission_history?.type === "V" ? "Vente" : e.commission_history?.type === "A" ? "Association" : e.commission_history?.type === "E" ? "Encaissement non récep." : e.commission_history?.type === "ER" ? "Encaissement réceptionné" : e.commission_history?.type === "EEI" ? "Encaissement à verser" : e.commission_history?.type === "EEncaisse" ? "Encaissement encaissé" : e.commission_history?.type === "EImpaye" ? "Encaissement impayé" : (e.commission_history?.type || ""))
    <>{(e.commission_history?.contrat?.NUM_DOSS ? /*`, */`Dossier N°${e.commission_history?.contrat?.NUM_DOSS}` : "")
    + (e.commission_history?.bien?.DESIGNATION ? /*`, */` [${e.commission_history?.bien?.DESIGNATION}]` : "")
    + (e.commission_history?.encaissement ? (", Réf. Règlement: " + (e.commission_history?.encaissement?.REF_REGLEMENT || "-")) : "")}</>,
    e.commission_history?.formulaId ? <div style={{...styles.formulaIdDiv, backgroundColor: constants.formulaIdColors[(e.commission_history.formulaId - 1) % constants.formulaIdColors.length]}}>{`- ${e.commission_history.formulaId} -`}</div> : "-",
    e.commission || 0,
    e.bonus_malus || 0,
    (e.commission || 0) + (e.bonus_malus || 0)
  ]);
  
  const formulaTags = formulaTagsExp.map(e => ({
    ...e,
    tag: <div style={{backgroundColor: e.color, color: "white"}}>{e.name}</div>
  }));

  const formatFormula = e => {
    const availableVars = getAvailableVarsComm(e)
    return {
      id: e.id,
      name: e.name,
      content: <div>
        {availableVars.map((t, key, arr) => <>
          <div>{t.o === 'p' ? <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n}%</b> ×</div> : <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).replace(/ /g, ' ')}&nbsp;DH</b> pour chaque</div>}&nbsp;{formulaTags.find(e => e.id === t.v)?.tag || null}</div>
          {!!(key < arr.length - 1) && " + "}
        </>)}
      </div>
    }
  }
  
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        {/* <Text>{fileObject && fileObject.toUpperCase()}</Text> */}
        <Text>{""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      <View fixed>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={{...styles.middleLogoText, ...(/*projet*/true ? styles.middleLogoTextTop : {paddingVertical: 10})}}>
                SHEMS AL MADINA
              </Text>
              {/* {projet ? <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                {projet.toUpperCase()}
              </Text> : null} */}
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                COMMISSIONS
              </Text>
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>
      
      <View style={styles.logoContainer} fixed>
        <View style={styles.clientTitleView1}>
          <View style={styles.clientTitleView2}>
            <Text>
              {bulletin.bulletinComUser ? bulletin.bulletinComUser["LOGIN"] : "-"} &nbsp;&nbsp; {((bulletin?.bonus_malus || 0) + lines.reduce((prev, b) => prev + (Number(b[columns.length - 1]) || 0), 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.bvView}>
        <View style={{flexDirection: "row"}}>
          <Text style={{fontWeight: 600}}>Bulletin N° : </Text><Text>{bulletin.id || "-"}</Text>
        </View>
        <View style={{flexDirection: "row"}}>
          <Text style={{fontWeight: 600}}>Projets : </Text><Text>{bulletin.commission_bulletin_lines?.filter((e, index, self) => self.findIndex(t => t.commission_history?.societeId === e.commission_history?.societeId) === index).map(e => e.commission_history?.societe?.LIBELE || "-").join(", ") || "-"}</Text>
        </View>
        <View style={{flexDirection: "row"}}>
          <Text style={{fontWeight: 600}}>Dates : </Text><Text>entre {firstDate ? moment(firstDate).format('DD/MM/YYYY') : "-"}</Text><Text>&nbsp;et&nbsp;</Text><Text>{lastDate ? moment(lastDate).format('DD/MM/YYYY') : "-"}</Text>
        </View>
        {!!bulletin?.comment && <View style={{flexDirection: "row"}}>
          <Text style={{fontWeight: 600}}>Commentaire : </Text><Text style={{maxWidth: "85%"}}>{bulletin.comment}</Text>
        </View>}
      </View>
      
      <View>
        <View style={{...styles.table, ...styles.lastElement}}>
          <View style={styles.tableRow} wrap={false}>
            {columns.map((e, key) => 
              <View style={{...styles.headerCol, width: e.width + "%"}} key={key}>
                <Text style={{...styles.cellText, ...styles.headerText}}>{ e.value }</Text>
              </View>
            )}
          </View>
          {lines.map((line, lineKey) => {
            return <View style={styles.tableRow} key={lineKey} wrap={false}>
              {line.map((e, key) => 
                <View style={{...styles.rowCol, width: columns[key].width + "%"}} key={key}>
                  <Text style={{...styles.cellText, fontSize: styles.cellText.fontSize + (columns[key].modifySizeBy || 0)}}>{ (e = e || 0, columns[key].formatNumber ? `${Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} DH` : columns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View>
          })}
          <View style={styles.tableRow} wrap={false}>
            <View style={{...styles.rowCol, ...styles.footerCol, width: columns[columns.length - 3].width + "%", marginLeft: columns.reduce((e, t, i) => {return i < columns.length - 3 ? e + (t.width || 0) : e}, 0) + "%"}}>
              <Text style={{...styles.cellText}}>{lines.reduce((prev, b) => prev + (Number(b[columns.length - 3]) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH</Text>
            </View>
            <View style={{...styles.rowCol, ...styles.footerCol, width: columns[columns.length - 2].width + "%"}}>
              <Text style={{...styles.cellText}}>{lines.reduce((prev, b) => prev + (Number(b[columns.length - 2]) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH</Text>
            </View>
            <View style={{...styles.rowCol, ...styles.footerCol, width: columns[columns.length - 1].width + "%"}}>
              <Text style={{...styles.cellText}}>{lines.reduce((prev, b) => prev + (Number(b[columns.length - 1]) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH</Text>
            </View>
          </View>
          <View style={styles.tableRow} wrap={false}>
            <View style={{...styles.rowCol, borderWidth: 0, width: columns.reduce((e, t, i) => {return i < columns.length - 1 ? e + (t.width || 0) : e}, 0) + "%"}}>
              <Text style={{...styles.cellText, textAlign: "right", fontWeight: 600}}>Bonus/Malus Global :&nbsp;</Text>
            </View>
            <View style={{...styles.rowCol, ...styles.footerCol, width: columns[columns.length - 1].width + "%"}}>
              <Text style={{...styles.cellText}}>{(bulletin?.bonus_malus || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH</Text>
            </View>
          </View>
          <View style={styles.tableRow} wrap={false}>
            <View style={{...styles.rowCol, borderWidth: 0, width: columns.reduce((e, t, i) => {return i < columns.length - 1 ? e + (t.width || 0) : e}, 0) + "%"}}>
              <Text style={{...styles.cellText, textAlign: "right", fontWeight: 600}}>Commission finale :&nbsp;</Text>
            </View>
            <View style={{...styles.rowCol, ...styles.footerCol, width: columns[columns.length - 1].width + "%"}}>
              <Text style={{...styles.cellText}}>{((bulletin?.bonus_malus || 0) + lines.reduce((prev, b) => prev + (Number(b[columns.length - 1]) || 0), 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"} DH</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.pageCountContainer} fixed>
        <View style={{marginBottom: 3}}>
          {usedFormulas.map(e => !!e && <Text style={{paddingVertical: 3}}>
            <div style={{...styles.formulaIdDiv, backgroundColor: constants.formulaIdColors[((e?.id || 0) - 1) % constants.formulaIdColors.length]}}>{`- ${e?.id || "-"} -`}</div>
            <Text>&nbsp;:&nbsp;</Text>
            {formatFormula(e).content}{!!e.name && <>&nbsp;&nbsp;(<Text style={{fontStyle: "italic", fontFamily: 'Open Sans'}}>{e.name}</Text>)</>}
          </Text>)}
        </View>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default CommissionDocument;
